import { ControlType, FetchStatus } from "../../../../base/types"
import { DetectFaceProperties, useDetectFaceProperties } from "./DetectFaceProperties"
import { ErrorMessage, Spinner } from "../../../../widgets"

import { DetectFace } from "./DetectFace"
import { DraftDetectFaceComponent } from "./DraftDetectFaceComponent"
import { FC } from "react"
import { IControlAttributes } from "../../../../base/models"
import { Registry } from "../../../../base/register"

export const DetectFaceComponent: FC<IControlAttributes> = ({
    className, props, children
}) => {
    const { status, properties, error } = useDetectFaceProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <>
        <DetectFace {...properties} className={className} />
    </>
}

Registry.addControl({
    id: "10bd32d0-abf1-4675-98d2-a0a9e45005ae",
    name: "Detect Face",
    type: ControlType.DetectFace,
    properties: DetectFaceProperties,
    component: DetectFaceComponent,
    draftComponent: DraftDetectFaceComponent
})